import { render, staticRenderFns } from "./expertWard.vue?vue&type=template&id=72ed04df&scoped=true"
import script from "./expertWard.vue?vue&type=script&lang=js"
export * from "./expertWard.vue?vue&type=script&lang=js"
import style0 from "./expertWard.vue?vue&type=style&index=0&id=72ed04df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed04df",
  null
  
)

export default component.exports